<template>
  <div class="bg-g3" style="height: 100%">
    <img
      class="logo margin-top-5x margin-left-24x"
      :src="uploadpath + 'resource/' + Res.vs_logo"
      alt=""
    />
    <div class="margin-top-5x flex-row flex-center">
      <div
        class="margin-left-3x width-3x border-5x"
        @click="type == '' ? choice(shop[0].id) : ''"
        :class="
          type == 'A' ? 'type_X' : 'type' && flag == '1' ? 'type_y' : 'type'
        "
      >
        <div style="position:relative">
          <div style="position: absolute;left: 0px;top: 0px;" class="icon-8x img_border"></div>
          <img
            class="icon-8x img_border"
            :src="uploadpath + 'shop/' + shop[0].image"
            alt=""
          />
        </div>
        <div
          class="h2 margin-top-3x margin-left margin-right chaochu"
          style="z-index: -1;"
        >
          {{ shop[0].name }}
        </div>
        <div
          class="
            f-24
            margin-top-3x margin-left margin-right
            padding-bottom-4x
            chaochu
          "
          :class="type == 'A' ? 'f-w' : 'f-g4'"
        >
          地址：{{ shop[0].address }}
        </div>
        <div
          class="t_a f-24 f-w border-under"
          :class="
            type != '' ? (type == 'A' ? 'bg-g11' : 'bg-g16') : 'display-none'
          "
          @click="enter(shop[0].id)"
        >
          进入店铺
        </div>
      </div>

      <img class="vs" :src="uploadpath + 'resource/' + Res.vs" alt="" />

      <div
        class="margin-left-1x width-3x border-5x"
        :class="
          type == 'B' ? 'type_X' : 'type' && flag == '2' ? 'type_y' : 'type'
        "
        @click="type == '' ? choice1(shop[1].id) : ''"
      >
      <div style="position:relative">
          <div style="position: absolute;left: 0px;top: 0px;" class="icon-8x img_border"></div>
          <img
            class="icon-8x img_border"
            :src="uploadpath + 'shop/' + shop[1].image"
            alt=""
          />
        </div>
        <div
          class="h2 margin-top-3x margin-left margin-right chaochu"
          style="z-index: -1;"
        >
          {{ shop[1].name }}
        </div>
        <div
          class="
            f-24
            margin-top-3x margin-left margin-right
            padding-bottom-4x
            chaochu
          "
          :class="type == 'B' ? 'f-w' : 'f-g4'"
        >
          地址：{{ shop[1].address }}
        </div>
        <div
          class="t_a f-24 f-w border-under"
          :class="
            type != '' ? (type == 'B' ? 'bg-g11' : 'bg-g16') : 'display-none'
          "
          @click="enter(shop[1].id)"
        >
          进入店铺
        </div>
      </div>
    </div>
    <div
      class="
        bg-w
        border-5x
        margin-left margin-right margin-top-3x
        padding-30-20
      "
    >
      <div class="f-24 f-g4">
        <div class="flex-row flex-center margin-bottom">
          <div
            class="bg-g14 margin-right-06x"
            style="height: 14px; width: 4px"
          ></div>
          <div class="f-24 f-b bold-5 border-10x border-none">操作说明</div>
        </div>
        {{ Inst.vs_explain }}
      </div>
    </div>
    <div class="margin-top-6x justify-center">
      <div class="margin-left-6x" style="width: 50%">
        <button
          class="bg-g15 h-80 width-25x border-none border-10x color-w h2"
          @click="back()"
        >
          返回
        </button>
      </div>
      <div class="margin-left-6x" style="width: 50%">
        <button
          class="bg-r1 h-80 width-25x border-none border-10x color-w h2"
          @click="change()"
        >
          换一组
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import Config from "../Config";
import { PageHelper } from "../PageHelper";
import { HttpHelper } from "../HttpHelper";
import { Utils } from "../Utils";

export default {
  data() {
    return {
      Res: {},
      Inst: {},
      Member: null,
      bannerlist: [],
      productlist: [],
      problemlist: [],
      attrlist: [],
      list: [],
      show: false,
      right: "A",
      shop: [],
      image: "",
      mlastclicktime: 0,
      mlastclicktime1: 0,
      type: "",
      return_id: 0,
      user_return_id: 0,
      mobile: "",
      flag: "",
    };
  },
  created() {
    PageHelper.Init(this);
    this.mobile = window.localStorage.getItem("mobile");
    HttpHelper.Post("Member/info", { phone: this.mobile }).then((ret) => {
      this.Member = ret;
    });
    HttpHelper.Post("shop/randomshop", { type: this.$route.params.type }).then(
      (ret) => {
        this.shop = ret;
        HttpHelper.Post("shop/shoprandom", {
          shop1: ret[0].id,
          shop2: ret[1].id,
        }).then((ret) => {
          this.return_id = ret.return;
        });
        // HttpHelper.Post("shop/userrandomshop", {
        //   shop1: ret[0].id,
        //   shop2: ret[1].id,
        //   member_id: this.Member.id,
        // }).then((ret) => {
        //   this.user_return_id=ret.return;
        // });
      }
    );
  },
  methods: {
    change() {
      HttpHelper.Post("shop/randomshop", {
        type: this.$route.params.type,
      }).then((ret) => {
        console.log(ret);
        this.shop = ret;
        HttpHelper.Post("shop/shoprandom", {
          shop1: ret[0].id,
          shop2: ret[1].id,
        }).then((ret) => {
          this.return_id = ret.return;
        });
        // HttpHelper.Post("shop/userrandomshop", {
        //   shop1: ret[0].id,
        //   shop2: ret[1].id,
        //   member_id: this.Member.id,
        // }).then((ret) => {
        //   this.user_return_id=ret.return;
        // });
      });
      this.type = "";
      this.flag = "";
    },
    back() {
      this.$router.back();
    },
    choice(id) {
      let time = parseInt(new Date().getTime());
      console.log(this.mlastclicktime, time);
      // new Data().getTime();
      if (time - this.mlastclicktime > 500) {
        this.mlastclicktime = time;
        console.log("单击");
        this.flag = "1";
        this.type = "";
        // return;
      } else {
        console.log("双击");
        this.mlastclicktime = 0;
        this.type = "A";
        this.flag = "";
        let name;
        if (this.type == "A") {
          name = this.shop[0].name;
        }
        HttpHelper.Post("shop/userrandomshop", {
          shop1: this.shop[0].id,
          shop2: this.shop[1].id,
          member_id: this.Member.id,
        }).then((ret) => {
          this.user_return_id = ret.return;
          HttpHelper.Post("shop/creatrecord", {
            shopid: id, //选中店铺id
            return_id: this.return_id, //店铺记录id
            user_return_id: this.user_return_id, //用户记录id
            type: this.type,
            member_id: this.Member.id,
            name: name,
            type_id: this.$route.params.type,
          }).then((ret) => {});
        });
        HttpHelper.Post("member/updatejifen",{
          member_id: this.Member.id,
          credit: this.Member.credit,
        }).then((res) =>{})
        // alert('走下来了。。。')

        // HttpHelper.Post("shop/shoprandom", {
        //   shop1: ret[0].id,
        //   shop2: ret[1].id,
        // }).then((ret) => {
        //   this.return_id=ret.return;
        // });
        // HttpHelper.Post("shop/userrandomshop", {
        //   shop1: this.shop[0].id,
        //   shop2: this.shop[1].id,
        //   member_id: this.Member.id,
        // }).then((ret) => {
        //   this.user_return_id=ret.return;
        // });
      }
    },
    choice1(id) {
      let time = parseInt(new Date().getTime());
      // new Data().getTime();
      if (time - this.mlastclicktime1 > 500) {
        this.mlastclicktime1 = time;
        console.log("单击");
        this.flag = "2";
        this.type = "";
        // return;
      } else {
        console.log("双击");
        this.type = "B";
        this.flag = "";
        let name;
        if (this.type == "B") {
          name = this.shop[1].name;
        }
        this.mlastclicktime1 = 0;
        HttpHelper.Post("shop/userrandomshop", {
          shop1: this.shop[0].id,
          shop2: this.shop[1].id,
          member_id: this.Member.id,
        }).then((ret) => {
          console.log(this.Member.id);
          this.user_return_id = ret.return;
          HttpHelper.Post("shop/creatrecord", {
            shopid: id,
            return_id: this.return_id,
            user_return_id: this.user_return_id,
            type: this.type,
            member_id: this.Member.id,
            name: name,
            type_id: this.$route.params.type,
          }).then((ret) => {});
        });
        HttpHelper.Post("member/updatejifen",{
          member_id: this.Member.id,
          credit: this.Member.credit,
        }).then((res) =>{})

        // HttpHelper.Post("shop/shoprandom", {
        //   shop1: ret[0].id,
        //   shop2: ret[1].id,
        // }).then((ret) => {
        //   this.return_id=ret.return;
        // });
      }
    },
    enter(id) {
      this.routeto("/detail/" + id + "/" + 0);
    },
  },
};
</script>
<style scoped>
.logo {
  height: 110px;
  width: 230px;
}
.vs {
  width: 90px;
  height: 120px;
}
.padding-30-20 {
  padding: 30px 20px;
}
.padding-10-20 {
  padding: 10px 20px;
}
.img_border {
  border-radius: 20px 20px 0 0;
}
.type {
  background: white;
  color: #333333;
}
.type_x {
  background: #a19a2a;
  color: white;
}
.type_y {
  background: white;
  color: #333333;
  border: 1px #a19a2a solid;
}
.t_a {
  text-align: center;
  line-height: 60px;
  height: 60px;
}
</style>


// WEBPACK FOOTER //
// src/components/Vs.vue